export default __webpack_public_path__ + "static/media/icon-coin-popcat.e8be4c38.svg";